import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { getAllContainers, getTilesFromShadow, updateTileHeights } from '../../utilities/icon-gallery-utils.js';
import css_248z from './icon-gallery-card.scss.js';

class IconGalleryCard extends s {
    constructor() {
        super(...arguments);
        this.size = 'small';
        this.outlined = false;
        this.outlineColor = 'purple';
        this.isIcon = true;
        this.titleSize = 'medium';
        this.titleColor = 'purple';
        this.ctaType = 'primary';
        this.textAlignment = 'center';
        this.iconSrc = '/assets/search-32.svg';
        this.iconContent = '';
    }
    updated() {
        const containers = getAllContainers('.grid-container');
        if (containers.length === 0)
            return;
        containers.forEach(container => {
            const tiles = getTilesFromShadow(container, 'icon-gallery-card', '.container-card');
            if (tiles.length === 0)
                return;
            updateTileHeights(tiles);
            const resizeObserver = new ResizeObserver(() => {
                updateTileHeights(tiles);
            });
            tiles.forEach(tile => resizeObserver.observe(tile));
            this.disconnectedCallback = () => {
                resizeObserver.disconnect();
            };
        });
    }
    render() {
        return $ `<div class="container-card"><div class="icon-circle circle-${this.size} ${this.outlined
            ? 'outlined'
            : ''} ${this.outlineColor} ${this.isIcon ? '' : 'filled'}"><slot name="icon" class="icon"></slot></div><div class="content text-alignment-${this.textAlignment}"><slot name="title" class="title title-${this.titleSize} title-color-${this.titleColor}"></slot><slot name="description" class="description"></slot></div><div class="cta-${this.ctaType}"><slot name="cta"></slot></div></div>`;
    }
}
IconGalleryCard.styles = css_248z;
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "size", void 0);
__decorate([
    e({ type: Boolean })
], IconGalleryCard.prototype, "outlined", void 0);
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "outlineColor", void 0);
__decorate([
    e({ type: Boolean })
], IconGalleryCard.prototype, "isIcon", void 0);
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "titleSize", void 0);
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "titleColor", void 0);
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "ctaType", void 0);
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "textAlignment", void 0);
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "iconSrc", void 0);
__decorate([
    e({ type: String })
], IconGalleryCard.prototype, "iconContent", void 0);
customElements.define('icon-gallery-card', IconGalleryCard);

export { IconGalleryCard };
